import React from "react";

const LoginNavContext = React.createContext({});

export default LoginNavContext;
